

// add more if needed
const getBioRoute = (googleBloggerUid) => {
    switch (googleBloggerUid) {
        case "11134329999510677716": return "/bio/shane-holinde"
        case "18041335258965923566": return "/about";
        default:
            return null;
    }
}

export default getBioRoute;